<template>
    <div class="simple-form flex col-2">
        <div class="form-group center">
            <div class="form-label">
                <label>业务单元</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.retailerComName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>所属部门</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.retailerBizUnitName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构标签</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.retailerComTagName || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>仓库名称</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.warehouseName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>来源单据类型</label>
            </div>
            <div class="form-value">
                <span>{{devcVoucherTypeMap[shopDeviceIoRecord.srcVoucherType]}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>来源单据号</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.srcVoucherNo}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>出入库</label>
            </div>
            <div class="form-value">
                <span>{{ioFlagMap[shopDeviceIoRecord.ioFlag]}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>{{shopDeviceIoRecord.lowCostFlag ? '耗材名称' : '资产描述全称'}}</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.title}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>批次号</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.batchNo || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>财务类别</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.assetKindName || ''}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>服务号</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.svcNo || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>分类</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.catName || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>分类分组</label>
            </div>
            <div class="form-value">
                <span>{{getGoodsCatDevcGroupName(shopDeviceIoRecord.catId) || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>品牌</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.brandName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>型号</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.model || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>规格</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.fixedSpec || '无'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>数量</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.quantity || 0}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>单位</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.theUnit || ''}}</span>
            </div>
        </div>
        <div class="form-group center" v-if="!shopDeviceIoRecord.durable">
            <div class="form-label">
                <label>是否租赁</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.rented ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{shopDeviceIoRecord.createTime}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>备注</label>
            </div>
            <div class="form-value" style="width: calc(100% - 126px - 20px);width: -webkit-calc(100% - 126px - 20px)">
                <span>{{shopDeviceIoRecord.memo || '无'}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDevcGroupNameByCatId } from '../index'
    //
    import shopDevcApi from '../../api/shopDevc'
    import assetVchrApi from '../../api/assetVchr'
    //
    export default {
        name: 'swb-shop-device-io-record-detail',
        desc: '（零售）店资产出入库记录详情',
        props: ['id'],
        data: function () {
            return {
                shopDeviceIoRecord: {},
                //
                ioFlagMap: {},
                devcVoucherTypeMap: {}
            }
        },
        created: function () {
            this.ioFlagMap = getEnumMap("ioFlag", "value2text");
            this.devcVoucherTypeMap = getEnumMap("devcVoucherType", "value2text");
            this.getShopDeviceIoRecordDetail();
        },
        methods: {
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getShopDeviceIoRecordDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceIoRecord(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.shopDeviceIoRecord = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceIoRecordDetail.vue